<!-- CmmClosed.vue -->
<script lang="ts" setup>
    import { onMounted, reactive, computed } from 'vue';
    import { ICoverMyMedsClosedModel } from '../../../../../lib/Api/CoverMyMeds';
    import { ChoiceApi } from '../../../../../LibMain';
    import { TextDisplayStyle } from '../../../../../Enums/UiEnums';
    import MessageText from '../../../../../components/Messages/MessageText.vue';
    import TitledRow from '../../../../../components/TitledRow.vue';
import CmmStatus from './CmmStatus.vue';

    const props = defineProps<{
        cmmEpaCallbackId: number
    }>();

    const compData = reactive<{
        status?: ICoverMyMedsClosedModel
    }>({});

    onMounted(async () =>{
        compData.status = await ChoiceApi.coverMyMeds.getClosedStatusData(props.cmmEpaCallbackId);
    });

    const status = computed<ICoverMyMedsClosedModel|undefined>(() => compData.status);
</script>

<template>
    <CmmStatus v-if="status" :status="status" :cmmEpaCallbackId="props.cmmEpaCallbackId" />

    <div v-if="status?.closedReasonCode">
        <hr/>
        <MessageText :displayStyle="TextDisplayStyle.Muted">
            <TitledRow title="Reason Code" >
                {{ status.closedReasonCode }}
            </TitledRow>
        </MessageText>
    </div>

</template>